import { Swiper } from 'swiper';
import {
	Navigation,
	EffectFade,
	Pagination,
	Autoplay,
	A11y,
} from 'swiper/modules';

const sliders = document.querySelectorAll('.block-hero-display .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		slider.parentElement.classList.add(
			`block-hero-display__swiper--${index}`
		);

		const settings = {
			autoplay: {
				enabled: true,
				delay: 6000,
			},
			grabCursor: false,
			allowTouchMove: false,
			spaceBetween: 0,
			slidesPerView: 1,
			modules: [A11y, Navigation, EffectFade, Pagination, Autoplay],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet(indexBullet, className) {
					return (
						'<span class="' +
						className +
						' swiper-slide-pagination"><span class="swiper-slide-pagination__number">' +
						(indexBullet + 1) +
						'</span><svg height="44" width="44" class="swiper-slide-pagination__circle"><circle cx="22" cy="22" r="21" stroke="#fff" stroke-width="1" fill="none"/></svg> </span>'
					);
				},
			},
		};

		new Swiper(slider, settings);
	});
}
